import React from "react";

export default function OrderTipRow({ tip }) {
  return (
    <div className="summary-row" style={{ display: "flex", justifyContent: "space-between", gap: 16, padding: "8px 0" }}>
      <span className="label">Tip</span>
      <span className="value">${Number(tip || 0).toFixed(2)}</span>
    </div>
  );
}
